import { type ShortUrlResponse } from '@air/api/types';

export const getFullShareUrl = (id: ShortUrlResponse['id'], searchParams?: URLSearchParams) =>
  `${window.location.origin}/a/${id}${!!searchParams ? `?${searchParams.toString()}` : ''}`;
